declare var swal: any;
import { Component, OnInit } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription, timer } from 'rxjs';
import { routerTransition } from '../../animations/router.animations';
import { NgbModal, NgbDateStruct, NgbModalOptions, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { NgbCounsellingRegistryModal } from './modal/counsellingregistry.modal';
import { CounsellingPlanController, SaveCounsellingPlanRequest, LabSpecimenCollectionController, LabSpecimenCollectionRequest, LabOrderDetailsController, LabOrderDetailsRequest, LabOrderTestsController, LabOrderTestsRequest, SaveSpecimenCollectionInfoRequest } from '../../../../../src/app/ncs/models/actor/actor';
import { CounsellingPlanRequest } from '../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../src/app/ncs/services/actor.service';
//import { NgbSearchPatientModal } from './modal/searchpatient.modal';
//import { NgbEditCounsellingPlanModal } from './modal/editcounsellingplan.modal';
import { NGXToastrService } from '../../../shared/services/toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbSpecimenCollection } from './specimencollection.modal';
import { PrintService } from '../../services/print.service';
@Component({
  selector: 'specimencollection2',
  templateUrl: './specimencollection2.component.html',
  styleUrls: ['./specimencollection2.component.css']
})
export class SpecimenCollection2Component implements OnInit {

  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }

  public ActorCode: string;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public ShowMonitoring: boolean = false;
  public ShowCounselling: boolean = true;
  public Showarrow: boolean = false;
  public isRequesting: boolean = false;
  public Laborder: any;
  public OrderTestStatus: any;
  public candisplayspe: boolean = false;
  public BranchName: any;
  public PatientFormttedCode: any;
  public date: Date;
  public date2: Date;
  DOB: NgbDateStruct;
  StartDate: NgbDateStruct;
  EndDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  searchTitle: string;
  public Selectedtoday: any;
  public SelectedDuration: any;
  public SelectedFromDate: any;
  public SelectedFromDatenew: NgbDateStruct;
  public SelectedToDatenew: NgbDateStruct;
  public SelectedToDate: any;
  public SelectedDepCode: any;
  public isdisplaydate: any;
  public SelectedFacilityCode: any;

  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;

  CurrentActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest;
  CurrentDashBoardProfileSummaryController: DashBoardProfileSummaryController;
  CurrentEditSaveSpecimenCollectionInfoRequest: SaveSpecimenCollectionInfoRequest;

  sub: Subscription;
  CurrentLabSpecimenCollectionController: LabSpecimenCollectionController[];
  CurrentLabSpecimenCollectionRequest: LabSpecimenCollectionRequest;
  //CurrentEditCounsellingPlanRequest: SaveCounsellingPlanRequest;
  //CurrentDeleteCounsellingPlanRequest: SaveCounsellingPlanRequest;
  LoadCounselling() {
    //this.CurrentEditCounsellingPlanRequest = new SaveCounsellingPlanRequest();
    //this.CurrentEditCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentLabSpecimenCollectionRequest = new LabSpecimenCollectionRequest();
    this.CurrentLabSpecimenCollectionRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentLabSpecimenCollectionRequest.LabOrderCode = this.Laborder;
    this.CurrentLabSpecimenCollectionRequest.ConditionalOperator = 10;
    this.GetLabSpecimenCollectionController();
  }

  //SelectedPatientEmergencyDetails: VitalLatestFormByFormattedCodeController;
  GetLabSpecimenCollectionController() {
    this.StartRefreshing();

    this.actorservice.GetLabSpecimenCollectionController(this.CurrentLabSpecimenCollectionRequest)
      .subscribe((result) => {
        this.stopRefreshing();
        try {
          this.ApiResData = result;
          if (this.ApiResData && !this.ApiResData.hasError) {
            this.CurrentLabSpecimenCollectionController = this.ApiResData.Result || [];
          }
          else {
            if (this.ApiResData && this.ApiResData.ErrorData != "") {
              alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            }
            else {
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            }
          }
        } catch (e) {
          console.error('Error in GetLabSpecimenCollectionController:', e);
        }
      },
      (error) => {
        this.stopRefreshing();
        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
        }
        else {
          alertFunctions.AlertParamEr(error);
        }
      });
  }

  Age: number;
  CurrentLabOrderDetailsController: LabOrderDetailsController[];
  Laborderdata: LabOrderDetailsController;
  CurrentLabOrderDetailsRequest: LabOrderDetailsRequest;

  LoadOrders() {
    this.CurrentLabOrderDetailsRequest = new LabOrderDetailsRequest();
    this.CurrentLabOrderDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentLabOrderDetailsRequest.ConditionalOperator = 10;
    this.CurrentLabOrderDetailsRequest.LabOrderCode = this.Laborder;
    this.GetLabOrderDetailsController();
  }

  GetLabOrderDetailsController() {
    this.StartRefreshing();

    this.actorservice.GetLabOrderDetailsController(this.CurrentLabOrderDetailsRequest)
      .subscribe((result) => {
        this.stopRefreshing();
        try {
          this.ApiResData = result;
          if (this.ApiResData && !this.ApiResData.hasError) {
            this.CurrentLabOrderDetailsController = this.ApiResData.Result || [];
            if (this.CurrentLabOrderDetailsController && this.CurrentLabOrderDetailsController.length > 0) {
              this.Laborderdata = this.CurrentLabOrderDetailsController[0];
              this.Age = this.CurrentLabOrderDetailsController[0].AgeYears;
            }
          }
          else {
            if (this.ApiResData && this.ApiResData.ErrorData != "") {
              alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            }
            else {
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            }
          }
        } catch (e) {
          console.error('Error in GetLabOrderDetailsController:', e);
        }
      },
      (error) => {
        this.stopRefreshing();
        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
        }
        else {
          alertFunctions.AlertParamEr(error);
        }
      });
  }

  public SpecimenShow: string;
  CurrentLabOrderTestsController: LabOrderTestsController[];
  LabSpecimens: LabOrderTestsController[];
  LabSpecimens2: LabOrderTestsController;
  CurrentLabOrderTestsRequest: LabOrderTestsRequest;

  LoadTests() {
    this.CurrentLabOrderTestsRequest = new LabOrderTestsRequest();
    this.CurrentLabOrderTestsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentLabOrderTestsRequest.ConditionalOperator = 10;
    this.CurrentLabOrderTestsRequest.LabOrderCode = this.Laborder;
    if (AppData.Instance().UserLoginDetails) {
      this.CurrentLabOrderTestsRequest.UserCode = AppData.Instance().UserLoginDetails.ActorCode;
    }
    this.GetLabOrderTestsController();
  }

  GetLabOrderTestsController() {
    this.StartRefreshing();

    this.actorservice.GetLabOrderTestsController(this.CurrentLabOrderTestsRequest)
      .subscribe((result) => {
        this.stopRefreshing();
        try {
          this.ApiResData = result;
          if (this.ApiResData && !this.ApiResData.hasError) {
            this.CurrentLabOrderTestsController = this.ApiResData.Result || [];

            var filterArray = (this.CurrentLabOrderTestsController || []).reduce((accumalator, current) => {
              if (current && current.Specimen && !accumalator.some(item => item.Specimen === current.Specimen)) {
                accumalator.push(current);
              }
              return accumalator;
            }, []);

            this.LabSpecimens = filterArray;
            this.LabSpecimens2 = this.ApiResData.Result;
            this.onSubmit2();
          }
          else {
            if (this.ApiResData && this.ApiResData.ErrorData != "") {
              alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            }
            else {
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            }
          }
        } catch (e) {
          console.error('Error in GetLabOrderTestsController:', e);
        }
      },
      (error) => {
        this.stopRefreshing();
        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
        }
        else {
          alertFunctions.AlertParamEr(error);
        }
      });
  }
  constructor(private router: Router,
    public printService: PrintService,
    private loaderService: SpinnerService,
    private spinner: NgxSpinnerService,
    private hcpservice: HCPService,
    private modalService: NgbModal,
    private tosterservice: NGXToastrService,
    private route: ActivatedRoute,
    private actorservice: ActorService,
    private loginservice: LoginService,
    private parserFormatter: NgbDateParserFormatter) { }

  ngOnInit() {
    this.spinner.hide();
    this.Laborder = this.route.snapshot.paramMap.get('Laborder');
    this.BranchName = this.route.snapshot.paramMap.get('BranchName');
    this.PatientFormttedCode = this.route.snapshot.paramMap.get('PatientFormttedCode');
    this.OrderTestStatus = this.route.snapshot.paramMap.get('OrderTestStatus');
    this.Selectedtoday = this.route.snapshot.paramMap.get('Selectedtoday');
    this.SelectedDuration = this.route.snapshot.paramMap.get('SelectedDuration');
    this.SelectedFromDate = this.route.snapshot.paramMap.get('SelectedFromDate');
    this.date = new Date(this.SelectedFromDate);
    this.SelectedFromDatenew = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: this.date.getDate() };
    this.SelectedToDate = this.route.snapshot.paramMap.get('SelectedToDate');
    this.date2 = new Date(this.SelectedToDate);
    this.SelectedToDatenew = { year: this.date2.getFullYear(), month: this.date2.getMonth() + 1, day: this.date2.getDate() };
    this.SelectedDepCode = this.route.snapshot.paramMap.get('SelectedDepCode');
    this.isdisplaydate = this.route.snapshot.paramMap.get('isdisplaydate');
    this.SelectedFacilityCode = this.route.snapshot.paramMap.get('SelectedFacilityCode');
    this.CurrentEditSaveSpecimenCollectionInfoRequest = new SaveSpecimenCollectionInfoRequest();
    this.CurrentEditSaveSpecimenCollectionInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //alert(this.Laborder);
    this.LoadCounselling();
    this.LoadOrders();
    this.LoadTests();
    // this.CurrentDeleteCounsellingPlanRequest = new SaveCounsellingPlanRequest();
    //this.CurrentDeleteCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }



  ShowList: boolean = true;




  BackToCounselling() {
    this.ShowCounselling = true;
    this.ShowMonitoring = false;
    this.Showarrow = false;
  }
  //SelectedPlan: CounsellingPlanController;
  //  edit(l: CounsellingPlanController) {

  //  this.CurrentEditCounsellingPlanRequest.Concerns = l.Concerns;
  //  this.CurrentEditCounsellingPlanRequest.ActorCode = l.ActorCode.toString();
  //  this.CurrentEditCounsellingPlanRequest.CounsellingDoctor = l.CounsellingDoctor;
  //    this.CurrentEditCounsellingPlanRequest.CounsellingPlanCode = l.CounsellingPlanCode;
  //    this.CurrentEditCounsellingPlanRequest.BranchCode = l.BranchCode;
  //  this.CurrentEditCounsellingPlanRequest.FinancialStatus = l.FinancialStatus;
  //  this.CurrentEditCounsellingPlanRequest.PackageCost = l.PackageCost;
  //  this.CurrentEditCounsellingPlanRequest.PlanStatus = l.PlanStatus;
  //  this.CurrentEditCounsellingPlanRequest.Potential = l.Potential;
  //  this.CurrentEditCounsellingPlanRequest.RecommendedPackage = l.RecommendedPackage;
  //  this.CurrentEditCounsellingPlanRequest.SelectEmi = l.SelectEmi;
  //    this.CurrentEditCounsellingPlanRequest.TreatmentPlan = l.TreatmentPlan;

  //  this.CurrentEditCounsellingPlanRequest.VisitCode = l.VisitCode.toString();
  //    this.CurrentEditCounsellingPlanRequest.EndDate = l.EndDate;
  //    this.CurrentEditCounsellingPlanRequest.ActorCode = l.ActorCode.toString();
  //    this.CurrentEditCounsellingPlanRequest.StartDate = l.StartDate;
  //    this.CurrentEditCounsellingPlanRequest.BranchCode = l.BranchCode;

  //  const modalRef = this.modalService.open(NgbEditCounsellingPlanModal,
  //  {
  //      centered: true,
  //      size: "lg"
  //    })
  //    modalRef.componentInstance.CurrentEditCounsellingPlanRequest = this.CurrentEditCounsellingPlanRequest;
  //    modalRef.componentInstance.FormattedCode = l.FormattedCode;
  //    modalRef.componentInstance.FacilityShortName = l.FacilityShortName;

  //  modalRef.result.then(x => { this.GetCounsellingPlanController() })
  //}




  ///////////
  //edit(objCategory: any) {
  //  var patient: CounsellingPlanController = objCategory;
  //  if (patient != null) {
  //    this.SelectedPlan = patient;
  //    let options: NgbModalOptions = {
  //      centered: true,
  //      size: "lg"
  //    };
  //    const modalRef = this.modalService.open(NgbEditCounsellingPlanModal, options)
  //    modalRef.componentInstance.FormattedCode = patient.FormattedCode;
  //    this.CurrentEditCounsellingPlanRequest.Concerns = patient.Concerns;
  //    this.CurrentEditCounsellingPlanRequest.ActorCode = patient.ActorCode.toString();
  // this.CurrentEditCounsellingPlanRequest.CounsellingDoctor = patient.CounsellingDoctor;
  //  this.CurrentEditCounsellingPlanRequest.CounsellingPlanCode = patient.CounsellingPlanCode;
  //    this.CurrentEditCounsellingPlanRequest.FinancialStatus = patient .FinancialStatus;
  //    this.CurrentEditCounsellingPlanRequest.PackageCost = patient.PackageCost;
  //    this.CurrentEditCounsellingPlanRequest.PlanStatus = patient.PlanStatus;
  //    this.CurrentEditCounsellingPlanRequest.Potential = patient.Potential;
  //    this.CurrentEditCounsellingPlanRequest.RecommendedPackage = patient.RecommendedPackage;
  //    this.CurrentEditCounsellingPlanRequest.SelectEmi = patient.SelectEmi;
  //    this.CurrentEditCounsellingPlanRequest.StartDate = patient.StartDate;
  //    this.CurrentEditCounsellingPlanRequest.TreatmentPlan = patient.TreatmentPlan;
  //    this.CurrentEditCounsellingPlanRequest.VisitCode = patient.VisitCode.toString();
  //    this.CurrentEditCounsellingPlanRequest.EndDate = patient.EndDate;

  //  }
  //}
  onSubmit2(e?: any) {
    var canTests = this.CurrentLabOrderTestsController ? this.CurrentLabOrderTestsController.find(x => x.IsSelected == true) : null;
    if (canTests == null) {
      this.candisplayspe = false;
    }
    else {
      var status = (this.OrderTestStatus || '').trim().toLowerCase();
      if (status === 'results pending' || status === 'results entered' || status === 'resutls entered' || status === 'pending') {
        this.candisplayspe = true;
      } else {
        this.candisplayspe = false;
      }
    }
  }
  SpecimenDetails(l: LabOrderTestsController) {

    const modalRef = this.modalService.open(NgbSpecimenCollection,
      {
        centered: true,
        size: "lg"

      })
    modalRef.componentInstance.PatientName = this.Laborderdata.PatientName;
    modalRef.componentInstance.Gender = this.Laborderdata.Gender;
    modalRef.componentInstance.Age = this.Age;
    modalRef.componentInstance.PatientFormttedCode = this.PatientFormttedCode;
    modalRef.componentInstance.Phonenumber = this.Laborderdata.Telephone1;
    modalRef.componentInstance.OrderId = l.LabOrderFormattedCode;
      //this.LabSpecimens[0].LabOrderFormattedCode;
    modalRef.componentInstance.Branch = this.Laborderdata.FacilityName;
    modalRef.componentInstance.OrderDate = this.Laborderdata.EffectiveOrderDate;
    // take off the tests that dont match the selectrd specimen
    this.CurrentLabOrderTestsController
      .filter(function (v: LabOrderTestsController, index: number, array: LabOrderTestsController[]) {
        return v.Specimen != l.Specimen
      }
      )
      .forEach(function (v: LabOrderTestsController, index: number, array: LabOrderTestsController[]) {
        v.IsSelected = false
      });

    // only the ones with selected sepecimen.. after above 
    modalRef.componentInstance.SelectedTests = this.CurrentLabOrderTestsController.filter(
      function (a) {
        return a.IsSelected == true
      });; //l.IsSelected
    modalRef.componentInstance.OrderCode = this.Laborderdata.LabOrderCode;
    modalRef.componentInstance.BranchCode = this.Laborderdata.Branch;
    modalRef.componentInstance.PatientCode = this.Laborderdata.PatientID;
    modalRef.componentInstance.Specimen = l.Specimen;
    //modalRef.componentInstance.Specimen = this.LabSpecimens[0].Specimen;
    modalRef.componentInstance.Mode = "Add";
    modalRef.result.then(x => { this.GetLabSpecimenCollectionController() })
  }
  SpecimenDetails2(l: LabSpecimenCollectionController) {
    // var x = l.SpecimenCollectionAmount;
    //var y: number = +x;
    this.CurrentEditSaveSpecimenCollectionInfoRequest.CollectionVolume = Number(l.SpecimenCollectionAmount);
    this.CurrentEditSaveSpecimenCollectionInfoRequest.CollectionDate = l.RecievedOn;
    this.CurrentEditSaveSpecimenCollectionInfoRequest.TestMethod = l.CollectionMethod;
    this.CurrentEditSaveSpecimenCollectionInfoRequest.DOC = Number(l.DOC);
    this.CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge1 = l.GestationAge1;
    this.CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge1Units = l.GestationAge1Units;
    this.CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge2 = l.GestationAge2;
    this.CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge2Units = l.GestationAge2Units;
    this.CurrentEditSaveSpecimenCollectionInfoRequest.Comments = l.Comments;
    this.CurrentEditSaveSpecimenCollectionInfoRequest.CollectionTime = l.SpecimenCollectionTime;
    this.CurrentEditSaveSpecimenCollectionInfoRequest.OrderTestSpecimenCollectionCode = l.OrderTestSpecimenCollectionCode;
    const modalRef = this.modalService.open(NgbSpecimenCollection,
      {
        centered: true,
        size: "lg"

      })
    modalRef.componentInstance.PatientName = this.Laborderdata.PatientName;
    modalRef.componentInstance.Gender = this.Laborderdata.Gender;
    modalRef.componentInstance.Age = this.Age;
    modalRef.componentInstance.PatientFormttedCode = this.PatientFormttedCode;
    modalRef.componentInstance.Phonenumber = this.Laborderdata.Telephone1;
    modalRef.componentInstance.OrderId = (this.LabSpecimens && this.LabSpecimens.length > 0) ? this.LabSpecimens[0].LabOrderFormattedCode : '';
    modalRef.componentInstance.Branch = this.Laborderdata.FacilityName;
    modalRef.componentInstance.OrderDate = this.Laborderdata.EffectiveOrderDate;
    modalRef.componentInstance.Tests = l.TestsName;
    modalRef.componentInstance.OrderCode = this.Laborderdata.LabOrderCode;
    modalRef.componentInstance.BranchCode = this.Laborderdata.Branch;
    modalRef.componentInstance.PatientCode = this.Laborderdata.PatientID;
    modalRef.componentInstance.Specimen = l.SpecimenCode;
    modalRef.componentInstance.Mode = "Edit";
    modalRef.componentInstance.CurrentEditSaveSpecimenCollectionInfoRequest = this.CurrentEditSaveSpecimenCollectionInfoRequest;
    modalRef.result.then(x => { this.GetLabSpecimenCollectionController() })
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.spinner.hide();
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.spinner.show();
    this.isRequesting = true;
  }

  Selectedpatient: CounsellingPlanController;
  Open(objCategory: any) {
    var patient: CounsellingPlanController = objCategory;
    if (patient != null) {
      this.Selectedpatient = patient;
      this.ShowMonitoring = true;
      this.ShowCounselling = false;
      this.Showarrow = true;
    }
    else {
      this.Selectedpatient = null;
    }
  }
  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }
  gotoviewprofile() {

    this.router.navigate(['testnurse/profileview']);
  }
  GetItems(LabType: string) {
    if (LabType != null && this.CurrentLabOrderTestsController && Array.isArray(this.CurrentLabOrderTestsController)) {
      var a = this.CurrentLabOrderTestsController.filter(X => X && X.LabType === LabType);
      return a;
    }
    return [];
  }
  GetSpecimen(Specimen: string) {
    if (Specimen != null && this.CurrentLabSpecimenCollectionController && Array.isArray(this.CurrentLabSpecimenCollectionController)) {
      var a = this.CurrentLabSpecimenCollectionController.filter(X => X && X.SpecimenCode === Specimen);
      return a;
    }
    return [];
  }
  trackBySpecimen(index: number, item: any): any {
    return item ? (item.Specimen || item.LabType || index) : index;
  }
  trackByTest(index: number, item: any): any {
    return item ? (item.OrderTestCode || item.TestName || index) : index;
  }
  trackBySpecimenCode(index: number, item: any): any {
    return item ? (item.OrderTestSpecimenCollectionCode || item.SpecimenFormattedCode || index) : index;
  }
  BackToProfile() {
    this.router.navigate(['healins/labdas', {
      Selectedtoday: this.Selectedtoday, SelectedDuration: this.SelectedDuration, SelectedFromDate2: new Date(this.parserFormatter.format(this.SelectedFromDatenew)), SelectedToDate: new Date(this.parserFormatter.format(this.SelectedToDatenew)), SelectedDepCode: this.SelectedDepCode, LoadData: "yes", isdisplaydate: this.isdisplaydate, SelectedFacilityCode: Number(this.SelectedFacilityCode)
    }]);
  }
  del_(l: LabSpecimenCollectionController) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(l.OrderTestSpecimenCollectionCode);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  private getResultValue(res: any): number {
    if (res === null || res === undefined) return 0;
    if (typeof res === 'number') return res;
    if (typeof res === 'string') return parseInt(res, 10) || 0;
    if (Array.isArray(res) && res.length > 0) {
      const first = res[0];
      if (typeof first === 'number') return first;
      if (typeof first === 'object' && first !== null) {
        if ('Result' in first && typeof first.Result === 'number') return first.Result;
        if ('Result' in first && typeof first.Result === 'string') return parseInt(first.Result, 10) || 0;
        const keys = Object.keys(first);
        if (keys.length > 0 && typeof first[keys[0]] === 'number') return first[keys[0]];
      }
      return res.length;
    }
    return 0;
  }

  DeleteActorIdentities(OrderTestCode: number) {
    this.CurrentEditSaveSpecimenCollectionInfoRequest.ConditionalOperator = 30;
    this.CurrentEditSaveSpecimenCollectionInfoRequest.OrderTestSpecimenCollectionCode = OrderTestCode;

    this.actorservice.SaveSpecimenCollectionInfo(this.CurrentEditSaveSpecimenCollectionInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          const resVal = this.getResultValue(result ? result.Result : null);
          if (resVal > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            this.LoadCounselling();
            this.LoadOrders();
            this.LoadTests();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }
      },
      (error) => {
        this.stopRefreshing();
        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
        }
        else {
          alertFunctions.AlertParamEr(error);
        }
      });
  }
  //AddPlan() {
  //  const modalRef = this.modalService.open(NgbCounsellingRegistryModal,
  //    {
  //      centered: true,
  //      size: 'lg'

  //    })

  //}

  //SearchPatient() {
  //  const modalRef = this.modalService.open(NgbSearchPatientModal,
  //    {
  //      centered: true,
  //      size: 'lg'
  //    })

  //  modalRef.result.then((val: string) => {
  //    //alert(val);
  //    const modalRef = this.modalService.open(NgbCounsellingRegistryModal,
  //      {
  //        centered: true,
  //        size: 'lg'
  //      })
  //    modalRef.componentInstance.FormattedCode = val;
  //    modalRef.result.then(x => { this.GetCounsellingPlanController()})
  //  });

  //}

  //del_(CounsellingPlanCode: any) {

  //  swal({
  //    title: 'Are you sure?',
  //    text: "You won't be able to revert this!",
  //    type: 'warning',
  //    showCancelButton: true,
  //    confirmButtonColor: '#0CC27E',
  //    cancelButtonColor: '#FF586B',
  //    confirmButtonText: 'Yes, delete it!',
  //    cancelButtonText: 'No, cancel!',
  //    confirmButtonClass: 'btn btn-success btn-raised mr-5',
  //    cancelButtonClass: 'btn btn-danger btn-raised',
  //    buttonsStyling: false
  //  }).then(() => {



  //    this.DeleteActorIdentities(CounsellingPlanCode);


  //  }, function (dismiss) {

  //    if (dismiss === 'cancel') {
  //      swal(
  //        'Cancelled',
  //        'Delete Operation Cancelled :)',
  //        'error'
  //      )
  //    }
  //  })
  //}
  specimen(l: LabOrderTestsController) {
    //alert("hello");
    this.printService.printDocument2(this.PatientFormttedCode, 0

    );
    this.printService.printDocument("labsample2",
      {
        PatientId: this.PatientFormttedCode,
        LabOrderCode: this.Laborderdata.LabOrderCode,
        Specimen: l.Specimen,
      },
    );
  }
}
